import { themeV2 as theme } from '@features/executive-report/domain/theme-v2';
import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { Slide } from '@features/powerpoint';

export const coverSlide = (title: string): Slide => {
  return {
    slideMaster: slideMasters.cover,
    texts: [
      {
        text: title,
        options: {
          fontSize: 36,
          bold: true,
          color: theme.colors.white,
          valign: 'middle',
          lineSpacingMultiple: 0.9,
          h: 0.75,
          w: 8.88,
          x: 3.44,
          y: 3.37,
        },
      },
    ],
  };
};
